<template>
    <div class="col-12">
        <h4>{{ __('advances_to_be_cleared') }}</h4>
        <DataTable
            :data="vatRates"
            :options="tableOptions"
            :summary="summary"
        />
    </div>
</template>

<script>
import DataTable from "../../../table/DataTable";

export default {
    name: "AdvanceToBeSettledTable",
    components: {DataTable},
    props: {
        contractItemsSummaries: {
            type: Object,
            required: true,
        },
        contractType: {
            type: Object,
            required: true,
        },
    },
    computed: {
        contractTable() {
            return {
                data: [
                    {name: this.__('item_vat_rate'), valueKey: 'vat_rate_list', type: ''},
                    {name: this.__('item_net_amount'), valueKey: 'net_advance_amount', type: 'money'},
                    {name: this.__('document_gross_amount'), valueKey: 'gross_advance_amount', type: 'money'},
                    {name: this.__('left_to_be_settled_net'), valueKey: 'net_advance_left', type: 'money'},
                    {name: this.__('left_to_be_settled_gross'), valueKey: 'gross_advance_left', type: 'money'},
                ],
                summary: [
                    {name: this.__('sum')},
                    {valueKey: 'sum_net_advance_amount', type: 'money'},
                    {valueKey: 'sum_gross_advance_amount', type: 'money'},
                    {valueKey: 'sum_net_advance_left', type: 'money'},
                    {valueKey: 'sum_gross_advance_left', type: 'money'},
                ],
            };
        },
        marginContractTable() {
            return {
                data: [
                    {name: '', value: this.__('total_advances'), type: ''},
                    {name: '', value:null, type: ''},
                    {name: this.__('value'), valueKey: 'gross_advance_amount', type: 'money'},
                    {name: '', value:null, type: ''},
                    {name: this.__('left_to_be_settled'), valueKey: 'gross_advance_left', type: 'money'},
                ]
            };
        },
        tableOptions() {
            return this.contractType.isMargin ? this.marginContractTable : this.contractTable;
        },
        summary() {
            return this.contractItemsSummaries.summary;
        },
        vatRates() {
            return this.contractItemsSummaries.vatRates;
        },
    },
};
</script>
